export const operationsRoutes = {
  operations: `/operations`,
} as const;
